import { defineMessages } from 'react-intl'

/** Cancellation, add-on, and car-hire style protection product names — see `docs/product-taxonomy.md` §6. */
const bookingProtectionGlossaryMessages = defineMessages({
  cancellationProtection: {
    defaultMessage: 'Cancellation Protection',
    id: 'h8QJyWvvzn-pIxyCw5hg',
    description: 'Base Luxury Escapes branded cancellation protection product name in checkout and order views',
  },
  enhancedProtection: {
    defaultMessage: 'Enhanced Protection',
    id: 'wxrDZjc4ak1FMIo0-AEz',
    description: 'Higher-excess or expanded cover tier label for car hire and add-on insurance comparison',
  },
  limitedProtection: {
    defaultMessage: 'Limited Protection',
    id: 'w97i7kcKrne37FBH5sAv',
    description: 'Reduced-coverage insurance tier label in car hire comparison tables and order summaries',
  },
  fullProtection: {
    defaultMessage: 'Full Protection',
    id: 'KspdBMSKCdZZIG7ZPlW9',
    description: 'Maximum coverage travel or rental insurance tier label in checkout review steps',
  },
  thirdPartyProtection: {
    defaultMessage: 'Third Party Protection',
    id: 'FIuqrKaHQCrPmhnekOxn',
    description: 'Third party liability or externally underwritten protection tier label in car hire flows',
  },
  baggageProtectionOnly: {
    defaultMessage: 'Baggage Protection Only',
    id: 'pDG96hlTASRd-7o53VOu',
    description: 'Product label when cover is limited to baggage only in insurance selection UI',
  },
  comprehensiveTravelProtection: {
    defaultMessage: 'Comprehensive Travel Protection',
    id: 'ZfpgL8tqBRdUbq-tPGNp',
    description: 'Marketing umbrella label for fully bundled travel protection on applicable packages',
  },
  atolProtection: {
    defaultMessage: 'ATOL Protection',
    id: 'F-NbA-bhZteqSFdIHXqO',
    description: 'UK ATOL financial protection label where applicable to flight-plus package products',
  },
  luxuryEscapesProtect: {
    id: '0S0grVKnoIqbUuyzU7xd',
    defaultMessage: 'Luxury Escapes Protect',
    description: 'Display name for the Luxury Escapes Protect embedded travel insurance product',
  },
  travelProtection: {
    defaultMessage: 'Travel Protection',
    id: 'vTr7585Re2b8k8k_kzwh',
    description: 'Generic section heading for travel protection or cancellation add-on in checkout',
  },
  iDontWantProtection: {
    defaultMessage: "I don't want protection",
    id: 'y-AaYX4-_w2ytvWUyPA2',
    description: 'Decline option when the customer opts out of adding travel or rental protection',
  },
  addProtection: {
    defaultMessage: 'Add protection',
    id: 'gY7xRsHbI7UxC3_Oocee',
    description: 'Accept call-to-action to add the selected travel or car hire protection to the basket',
  },
  customiseTravelProtection: {
    defaultMessage: 'Customise your travel protection',
    id: 'NsBXpudRuAEiTq34uZ5W',
    description: 'Step or modal heading when editing travel insurance options before payment',
  },
  coverGeniusTravelProtection: {
    defaultMessage: 'Cover Genius Travel protection',
    id: 'HQuzSGNRuGIuerMaPus4',
    description: 'Partner-branded label for Cover Genius underwritten travel protection in checkout',
  },
})

export default bookingProtectionGlossaryMessages
